import classNames from "classnames/bind"
import PropTypes from "prop-types"
import React from "react"

import { useTranslate } from "context/translateContext"
import { capitalizeFirstLetter } from "shared/helpers/strings"

import gridStyles from "../../../components/Plans.module.css"

const cx = classNames.bind(gridStyles)

const bodyClass = cx("row", "planCell")

const Support = ({ plans }) => {
  const { t: translate } = useTranslate()
  return (
    <>
      <div
        className={cx(bodyClass, "mobileHeading", "featureDescriptionLastCell")}
      >
        <p className={gridStyles.sectionTitle}>{translate("Support")}</p>
      </div>
      {plans.map(plan => {
        const channelsListLength = plan?.support_channels?.length
        return (
          <div key={`SUPPORT_${plan.name}`} className={bodyClass}>
            <div className="flex-container fullheight wd100 f-a-start f-j-center textCenter">
              <p className="m-b-0 fs-18 w300">
                {plan?.support_channels?.includes("account manager") ? translate("All support options, plus Account Manager") : plan?.support_channels?.map((channel, index) => {
                  if (index === 0)
                    return `${translate(capitalizeFirstLetter(channel))}, `
                  if (index + 1 === channelsListLength)
                    return `${translate(channel)}`
                  return `${translate(channel)}, `
                })}
              </p>
            </div>
          </div>
        )
      })}
    </>
  )
}

Support.propTypes = { plans: PropTypes.array }
Support.defaultProps = { plans: [] }

export default Support
